// removed by extract-text-webpack-plugin
module.exports = {"container":"src-styles-components----featured-module---container---FIZsW src-styles-components----container-module---container---1YJKJ","title":"src-styles-components----featured-module---title---2NrYj"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/featured.module.scss
// module id = 392
// module chunks = 72116242359702